import { render } from "./ForgotPasswordBody.vue?vue&type=template&id=af7414b6"
import script from "./ForgotPasswordBody.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__